var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_1614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1008 29.9277C9.42856 28.7944 7.25738 27.0826 5.58724 24.7923C3.9171 22.502 3.08203 19.9166 3.08203 17.0361C3.08203 16.4222 3.11415 15.8201 3.17839 15.2298C3.24262 14.6395 3.35182 14.0611 3.50599 13.4944L1.73307 14.4507L0.191406 12.0069L7.55286 8.11107L11.7924 14.8402L9.09453 16.2569L7.01328 12.9277C6.73064 13.5652 6.51866 14.2263 6.37734 14.9111C6.23602 15.5958 6.16536 16.3041 6.16536 17.0361C6.16536 19.3263 6.84627 21.41 8.20807 23.2871C9.56988 25.1642 11.3813 26.5513 13.6424 27.4486L12.1008 29.9277ZM23.8945 12.7507V9.91732H28.0956C26.9136 8.57148 25.4876 7.52669 23.8174 6.78294C22.1473 6.03919 20.3744 5.66732 18.4987 5.66732C17.0855 5.66732 15.7494 5.86801 14.4904 6.2694C13.2313 6.67079 12.0751 7.23746 11.0216 7.9694L9.47995 5.49023C10.7647 4.66385 12.165 4.01454 13.681 3.54232C15.197 3.0701 16.8029 2.83398 18.4987 2.83398C20.5286 2.83398 22.4685 3.18225 24.3185 3.87878C26.1685 4.5753 27.8258 5.58468 29.2904 6.9069V4.95898H32.3737V12.7507H23.8945ZM22.8924 34.0007L15.531 30.1048L19.7706 23.3757L22.4299 24.7923L20.2331 28.2632C23.265 27.8618 25.7895 26.5986 27.8065 24.4736C29.8235 22.3486 30.832 19.8576 30.832 17.0007C30.832 16.7409 30.8256 16.4989 30.8128 16.2746C30.7999 16.0503 30.7678 15.8201 30.7164 15.584H33.8383C33.864 15.8201 33.8832 16.0503 33.8961 16.2746C33.9089 16.4989 33.9154 16.7409 33.9154 17.0007C33.9154 20.1882 32.8812 23.0392 30.8128 25.5538C28.7444 28.0684 26.0529 29.7625 22.7383 30.6361L24.4341 31.5569L22.8924 34.0007Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.2f664aa75589d211083231cd35c13e92.svg";
export { ForwardRef as ReactComponent };